<template>
	<section>
		<ButtonBack />
		<el-row>
			<el-col :sm="12">
				<h1>User</h1>
			</el-col>
			<el-col :sm="12" class="flex flex--justifyend button-panel">
				<TheButton type="default" @buttonclick="importDialogVisible = true">
					<el-icon><Plus /></el-icon>User-Import (CSV)
				</TheButton>
				<RouterLink :to="'/user-anlegen'" class="el-button el-button--danger is-round" :title="'Neuen User anlegen'">
					<el-icon><Plus /></el-icon>Neuer User
				</RouterLink>
			</el-col>
		</el-row>

		<h2>Filter</h2>
		<TheForm :model="request" :rules="rules" :id="id" ref="formRef" :persistForm="true" formNamespace="userFilter" :autoSave="true">
			<el-row>
				<el-form-item label="Freitextsuche" prop="searchTerm" class="el-col el-col-24 el-col-sm-12 el-col-xs-24">
					<el-input v-model="request.searchTerm" placeholder="Suche" clearable />
				</el-form-item>

				<el-col :sm="12" :xs="24">
					<el-row>
						<el-form-item label="Pro-Ethik-Siegel" prop="hasSeal" class="el-col el-col-24 el-col-sm-12 el-col-xs-24">
							<el-select v-model="request.hasSeal" placeholder="Alle">
								<el-option v-for="item in hasSealOptions" :key="item.value" :label="item.label" :value="item" />
							</el-select>
						</el-form-item>
						<el-form-item
							label="Entscheidungen unter 25%"
							prop="lessThanTwentyFivePercentDecisions"
							class="el-col el-col-24 el-col-sm-12 el-col-xs-24"
						>
							<el-select v-model="request.lessThanTwentyFivePercentDecisions" placeholder="Alle">
								<el-option v-for="item in decisionPercentOptions" :key="item.value" :label="item.label" :value="item" />
							</el-select>
						</el-form-item>
					</el-row>
				</el-col>
			</el-row>

			<el-row>
				<el-form-item label="Gruppe" prop="role" class="el-col el-col-24 el-col-sm-12 el-col-xs-24">
					<el-select v-model="request.role" placeholder="Alle">
						<el-option v-for="item in userRoleOptions" :key="item.value" :label="item.label" :value="item" />
					</el-select>
				</el-form-item>

				<el-form-item label="User Status" prop="status" class="el-col el-col-24 el-col-sm-12 el-col-xs-24">
					<el-select v-model="request.status" placeholder="Alle">
						<el-option v-for="item in userStatusOptions" :key="item.value" :label="item.label" :value="item" />
					</el-select>
				</el-form-item>
			</el-row>

			<el-row>
				<el-form-item label="Zeitraum (Erstellung)" prop="timePeriod" class="el-col el-col-24 el-col-sm-12 el-col-xs-24">
					<el-checkbox-group v-model="selectedTimePeriod" placeholder="Alle">
						<el-checkbox
							v-for="item in timePeriodOptions"
							:key="item.value"
							:value="item.value"
							:border="true"
							@change="() => handleClickOptionWrapper(item)"
						>
							{{ item.label }}
						</el-checkbox>
					</el-checkbox-group>
				</el-form-item>
				<el-col :sm="4" :xs="24"></el-col>
				<el-form-item label="" prop="dateRange" class="el-col el-col-24 el-col-sm-8 el-col-xs-24">
					<div class="datepicker-range__labels">
						<label class="el-form-item__label">Von</label>
						<label class="el-form-item__label">Bis</label>
					</div>
					<el-date-picker
						v-model="dateRange"
						type="daterange"
						:format="'DD.MM.YYYY'"
						range-separator=""
						:clearable="true"
						start-placeholder="TT.MM.JJJJ"
						end-placeholder="TT.MM.JJJJ"
					/>
				</el-form-item>
			</el-row>
			<el-row class="button-panel">
				<TheButton
					type="danger"
					@buttonclick="
						tablePage = 0;
						doSearch();
					"
					isSubmit
					>Anwenden</TheButton
				>
				<TheButton type="default" @buttonclick="resetSearch">
					<el-icon><Close /></el-icon>
					Filter zurücksetzen
				</TheButton>
			</el-row>
		</TheForm>
	</section>

	<div class="bg--white">
		<section id="searchresults">
			<el-row class="flex flex--justifyspacebetween">
				<h2>User ({{ $getCountErgebnisseLabel(usersTotalCount) }})</h2>
				<TheButton type="default" @buttonclick="exportCsv" :loading="csvExportLoading">
					<svg v-if="!csvExportLoading" width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg" style="margin-right: 6px">
						<path d="M8 1L13 6.00248L8 11" stroke="#2E3A50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
						<path d="M1 6L13 6" stroke="#2E3A50" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
					</svg>
					Ergebnis exportieren (CSV)
				</TheButton>
			</el-row>
			<UsersOrContactsTable
				:loading="usersTableLoading"
				:isUsersTable="true"
				:tableData="filteredUsers"
				:totalCount="usersTotalCount"
				@loadNextPage="loadNextPage"
			/>
		</section>
	</div>

	<!-- CSV Import Dialog -->
	<el-dialog v-model="importDialogVisible" title="User importieren (CSV)" @close="resetImportDialog">
		<!-- idle State: Upload -->
		<template v-if="importState === 'idle'">
			<el-upload
				ref="csvUpload"
				drag
				action=""
				:file-list="importFileList"
				:auto-upload="false"
				accept=".csv"
				:multiple="false"
				:limit="1"
				:on-change="handleImportFileChange"
				:on-remove="handleImportFileRemove"
			>
				<el-icon class="el-icon--upload"><UploadFilled /></el-icon>
				<div class="el-upload__text">CSV-Datei hier ablegen oder <em>auswählen</em></div>
			</el-upload>

			<el-row class="flex flex--aligncenter flex--justifyspacebetween" style="margin-top: 8px">
				<span class="el-upload__tip" style="margin: 0">Zugelassen: CSV mit einer Größe bis 2 MB</span>
				<a href="#" class="csv-import__sample-link" @click.prevent="downloadSampleCsv">Muster-CSV downloaden</a>
			</el-row>
		</template>

		<!-- success State -->
		<template v-if="importState === 'success'">
			<div class="csv-import__result csv-import__result--success">
				<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
					<circle cx="16" cy="16" r="16" fill="white" fill-opacity="0.3" />
					<path d="M10 16.5L14 20.5L22 12.5" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
				</svg>
				<span>Erfolg: {{ importSuccessCount }} User {{ importSuccessCount === 1 ? 'wurde' : 'wurden' }} neu angelegt.</span>
			</div>
		</template>

		<!-- error State -->
		<template v-if="importState === 'error'">
			<div class="csv-import__result csv-import__result--error">
				<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M14.268 5.5C15.038 4.167 16.962 4.167 17.732 5.5L28.124 23.5C28.894 24.833 27.932 26.5 26.392 26.5H5.608C4.068 26.5 3.106 24.833 3.876 23.5L14.268 5.5Z"
						fill="white"
						fill-opacity="0.3"
					/>
					<path d="M16 12V18" stroke="white" stroke-width="2.5" stroke-linecap="round" />
					<circle cx="16" cy="22" r="1.5" fill="white" />
				</svg>
				<span>Fehler: User wurden nicht importiert.</span>
			</div>

			<div class="csv-import__errors">
				<p class="csv-import__errors-header">{{ totalErrorCount }} Fehler: Detailinformationen</p>
				<div class="csv-import__errors-list">
					<div v-for="(err, i) in importErrors" :key="i" class="csv-import__error-row">
						<strong v-if="err.rowNumber > 0">Fehler in Zeile {{ err.rowNumber }}:</strong>
						<strong v-else>Fehler:</strong>
						{{ err.email }}
						<ul v-if="err.fieldErrors.length > 0">
							<li v-for="(fieldErr, j) in err.fieldErrors" :key="j">{{ fieldErr }}</li>
						</ul>
					</div>
				</div>
				<p class="csv-import__errors-footer">Bitte korrigieren Sie die CSV-Datei und laden Sie sie erneut hoch.</p>
			</div>
		</template>

		<template #footer>
			<div class="button-panel">
				<template v-if="importState === 'success'">
					<TheButton type="danger" @buttonclick="closeImportDialog">Schließen</TheButton>
				</template>
				<template v-else-if="importState === 'error'">
					<TheButton type="danger" @buttonclick="retryImport">Korrigierte Datei hochladen</TheButton>
					<TheButton type="default" @buttonclick="closeImportDialog">Abbrechen</TheButton>
				</template>
				<template v-else>
					<TheButton type="danger" @buttonclick="doImport" :loading="importLoading" :disabled="!importFile">Importieren</TheButton>
					<TheButton type="default" @buttonclick="closeImportDialog">Abbrechen</TheButton>
				</template>
			</div>
		</template>
	</el-dialog>
</template>

<script lang="ts">
import UsersOrContactsTable from '@/components/tables/UsersOrContactsTable.vue';
import { searchUsers } from '@/requests/searches';
import { exportUsersCsv, downloadSampleCsv, importUsersCsv } from '@/requests/csvExport';
import { SearchUserRequest, UserResponse } from '@/types/types';
import { resetForm, validateForm } from '@/utils/functions';
import { handleClickTimePeriodOptionCheckbox, handleSearchDateRangeChange, prepareSearchRequest } from '@/utils/search/searchUtils';
import { Close, Plus, UploadFilled } from '@element-plus/icons-vue';
import type { FormInstance } from 'element-plus';
import { defineComponent, ref } from 'vue';
import ButtonBack from '../components/buttons/ButtonBack.vue';
import TheButton from '../components/TheButton.vue';
import TheForm from '../components/TheForm.vue';
import { returnFormOptions } from '../utils/formOptions.js';
import { texts } from '../utils/texts';
import { ErrorCodes, getErrorCode, getErrorMessage } from '@/utils/errorHandling';
import type { UploadUserFile } from 'element-plus';

interface ImportRowError {
	rowNumber: number;
	email: string;
	fieldErrors: string[];
}

interface SearchUsersData {
	request: SearchUserRequest;
	rules: Object;
	id: string;
	dateRange: string[] | null;
	selectedTimePeriod: any[];
	tablePage: number;
	itemsPerPage: number;
	filteredUsers: UserResponse[];
	usersTotalCount: number;
	usersTableLoading: boolean;
	csvExportLoading: boolean;
	importDialogVisible: boolean;
	importState: 'idle' | 'success' | 'error';
	importLoading: boolean;
	importFile: File | null;
	importFileList: UploadUserFile[];
	importSuccessCount: number;
	importErrors: ImportRowError[];
}

export default defineComponent({
	name: 'UserView',
	data(): SearchUsersData {
		return {
			request: {
				searchTerm: '',
				role: null,
				hasSeal: null,
				lessThanTwentyFivePercentDecisions: null,
				fromDate: null,
				toDate: null,
				status: null,
			},
			rules: {},
			id: 'searchForm',
			dateRange: null,
			selectedTimePeriod: [],
			tablePage: 0,
			itemsPerPage: 14,
			filteredUsers: [],
			usersTotalCount: 0,
			usersTableLoading: false,
			csvExportLoading: false,
			importDialogVisible: false,
			importState: 'idle',
			importLoading: false,
			importFile: null,
			importFileList: [],
			importSuccessCount: 0,
			importErrors: [],
		};
	},
	setup() {
		const formRef = ref<FormInstance>();
		return {
			formRef,
		};
	},
	components: {
		ButtonBack,
		TheButton,
		TheForm,
		Plus,
		Close,
		UploadFilled,
		UsersOrContactsTable,
	},
	computed: {
		userRoleOptions() {
			return returnFormOptions('userRole', false, true);
		},
		userStatusOptions() {
			return returnFormOptions('userStatus');
		},
		hasSealOptions() {
			return returnFormOptions('hasSeal');
		},
		decisionPercentOptions() {
			return returnFormOptions('decisionPercent');
		},
		timePeriodOptions() {
			return returnFormOptions('timePeriod');
		},
		totalErrorCount(): number {
			return this.importErrors.reduce((sum, err) => sum + err.fieldErrors.length, 0);
		},
	},
	methods: {
		handleClickOptionWrapper(item) {
			const { newSelectedTimePeriod, newTimePeriodOptions, newDateRange } = handleClickTimePeriodOptionCheckbox(
				item,
				this.selectedTimePeriod,
				this.timePeriodOptions,
			);

			this.selectedTimePeriod = newSelectedTimePeriod;
			this.timePeriodOptions = newTimePeriodOptions;
			this.dateRange = newDateRange;
		},
		resetSearch() {
			resetForm(this.formRef, this.id);
			this.dateRange = null;
			this.tablePage = 0;
			this.doSearch();
		},
		async doSearch() {
			const isValid = await validateForm(this.formRef, this.id);
			if (!isValid) return;

			this.usersTableLoading = true;

			const searchRequest = prepareSearchRequest(this.request);
			const searchResult = await searchUsers(searchRequest, this.tablePage, this.itemsPerPage);
			if (searchResult.success) {
				this.usersTotalCount = searchResult.data.totalCount;
				if (this.tablePage === 0) {
					this.filteredUsers = searchResult.data.items;
				} else {
					this.filteredUsers = [...this.filteredUsers, ...searchResult.data.items];
				}
			} else {
				this.filteredUsers = [];
				this.usersTotalCount = 0;
			}
			this.usersTableLoading = false;
		},
		handleImportFileChange(file: UploadUserFile) {
			if (file.raw) {
				if (file.raw.size > 2 * 1024 * 1024) {
					this.importFileList = [];
					this.importFile = null;
					return;
				}
				this.importFile = file.raw;
			}
		},
		handleImportFileRemove() {
			this.importFile = null;
			this.importFileList = [];
		},
		async doImport() {
			if (!this.importFile) return;

			this.importLoading = true;

			try {
				const response = await importUsersCsv(this.importFile);
				this.importState = 'success';
				this.importSuccessCount = response.count;
			} catch (error: any) {
				this.importState = 'error';
				this.importFile = null;
				this.importFileList = [];

				const unknownError = 'Ein unbekannter Fehler ist aufgetreten.';
				const errorData = error?.response?.data;
				const mapRowErrors = (rows: any[]): ImportRowError[] =>
					rows.map((e: any) => ({
						rowNumber: e.rowNumber ?? e.RowNumber ?? 0,
						email: e.email ?? e.Email ?? '',
						fieldErrors: e.fieldErrors ?? e.FieldErrors ?? [],
					}));

				if (getErrorCode(errorData) === ErrorCodes.CsvImportValidationFailed && Array.isArray(errorData?.rowErrors)) {
					// ProblemDetails mit Zeilenfehlern in der Extension rowErrors
					this.importErrors = mapRowErrors(errorData.rowErrors);
				} else {
					// TODO OEWR-91: Fallback nach Prod-Release entfernen — alter Vertrag: Zeilenfehler als JSON-Array-String
					let legacyRows: any = null;
					if (typeof errorData === 'string') {
						try {
							legacyRows = JSON.parse(errorData);
						} catch {
							legacyRows = null;
						}
					} else if (Array.isArray(errorData)) {
						legacyRows = errorData;
					}

					if (Array.isArray(legacyRows)) {
						this.importErrors = mapRowErrors(legacyRows);
					} else {
						this.importErrors = [{ rowNumber: 0, email: '', fieldErrors: [getErrorMessage(errorData, unknownError)] }];
					}
				}
			} finally {
				this.importLoading = false;
			}
		},
		retryImport() {
			this.importState = 'idle';
			this.importFile = null;
			this.importFileList = [];
			this.importErrors = [];
		},
		resetImportDialog() {
			this.importState = 'idle';
			this.importFile = null;
			this.importFileList = [];
			this.importSuccessCount = 0;
			this.importErrors = [];
		},
		closeImportDialog() {
			this.importDialogVisible = false;
			if (this.importState === 'success') {
				this.tablePage = 0;
				this.doSearch();
			}
		},
		async downloadSampleCsv() {
			try {
				await downloadSampleCsv();
			} catch (error) {
				console.error('Sample CSV download failed:', error);
			}
		},
		async exportCsv() {
			this.csvExportLoading = true;
			try {
				const searchRequest = prepareSearchRequest(this.request);
				await exportUsersCsv(searchRequest);
			} catch (error) {
				console.error('CSV export failed:', error);
			} finally {
				this.csvExportLoading = false;
			}
		},
		loadNextPage() {
			this.tablePage++;
			this.doSearch();
		},
	},
	mounted() {
		if (this.$route.query.searchTerm) {
			this.request.searchTerm = String(this.$route.query.searchTerm);
		}

		if (this.$route.query.gruppe) {
			// @ts-ignore
			const foundRole = this.userRoleOptions.find((role) => role.label.toLowerCase() === this.$route.query.gruppe.toLowerCase());
			if (foundRole) {
				this.request.role = foundRole;
			}
		}

		this.doSearch();
	},
	watch: {
		dateRange: {
			handler(val) {
				if (val && val.length === 2) {
					const { fromDate, toDate } = handleSearchDateRangeChange(val);
					this.request.fromDate = fromDate;
					this.request.toDate = toDate;
				} else {
					this.request.fromDate = null;
					this.request.toDate = null;
					this.selectedTimePeriod = [];
					this.timePeriodOptions.forEach((option: any) => (option.checked = false));
				}
			},
			deep: true,
		},
		request: {
			handler() {
				if (this.request.fromDate && this.request.toDate) {
					this.dateRange = [this.request.fromDate, this.request.toDate];
				}
			},
			deep: true,
		},
	},
});
</script>
